const fixCv = document.querySelector('.fixCv')
const footer = document.querySelector('.footer')

const topMv = document.querySelector('.topMv')
const topNews = document.querySelector('.topMv__news')
const topCta = document.querySelector('.topCta')

if (fixCv) {
  if (topNews) {
    const handleTransitionEnd = (event) => {
      if (event.target !== topNews || event.propertyName !== 'clip-path') {
        return
      }
      fixCv.classList.remove('is_loading')
      topNews.removeEventListener('transitionend', handleTransitionEnd)
    }

    topNews.addEventListener('transitionend', handleTransitionEnd)
  }

  const update = () => {
    const isSmall = window.innerWidth <= 768
    const fixCvHeight = fixCv.getBoundingClientRect().height
    const mvRect = topMv ? topMv.getBoundingClientRect() : null
    const ctaRect = topCta ? topCta.getBoundingClientRect() : null
    const footerRect = footer ? footer.getBoundingClientRect() : null

    const mvHide =
      mvRect && isSmall && mvRect.top < window.innerHeight && mvRect.bottom > window.innerHeight - fixCvHeight
    const ctaInView = ctaRect && ctaRect.top < window.innerHeight && ctaRect.bottom > 0
    const footerInView = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0

    if (mvHide || ctaInView || footerInView) {
      fixCv.classList.add('is_hide')
      return
    }

    fixCv.classList.remove('is_hide')
  }

  window.addEventListener('load', update)
  window.addEventListener('resize', update)
  window.addEventListener('scroll', update, { passive: true })
  update()

  // document.querySelectorAll('.fixCv__btnText').forEach((item) => {

  // })
}
